/**
 * Toggle a value in a multi-select filter array.
 * Returns null if the toggle would remove the last selection (not allowed).
 */
export function toggledFilterArray(value, array) {
  const next = array.includes(value)
    ? array.filter((v) => v !== value)
    : [...array, value];
  return next.length === 0 ? null : next;
}
